import * as React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { genero } from '../../constants/FieldsConst';
import { validFielddHelper } from '../../helpers/ValidFieldsHelper';

export const generosArray = [
  { id: 'M', nombre: 'MASCULINO' },
  { id: 'F', nombre: 'FEMENINO' },
];

export const generosEnum = {
  M: 'MASCULINO',
  F: 'FEMENINO',
};

export const getGenero = (value) => {
  const d = generosArray.find((el) => el.id === value);
  return d?.nombre ?? '';
};

const GenerosField = ({
  onChange,
  required,
  value,
  helperText,
  error,
  disabled,
}) => {
  const xName = 'Género';

  return (
    <FormControl fullWidth error={error} size="small" required>
      <InputLabel id={genero.name}>{xName}</InputLabel>
      <Select
        labelId={genero.name}
        id={genero.name}
        value={value}
        label={xName}
        required={required}
        disabled={disabled}
        onChange={onChange}
      >
        {generosArray.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.nombre}
            </MenuItem>
          );
        })}
      </Select>
      {error && (
        <FormHelperText>
          {helperText ?? error ? validFielddHelper(1) : null}
        </FormHelperText>
      )}
    </FormControl>
  );
};

GenerosField.propTypes = {
  value: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default GenerosField;
